export default {"src":"/polygon/_next/static/media/immunefi.0fb71f5f.svg","height":64,"width":64};